import { render } from "./ImgBlock.vue?vue&type=template&id=269b42a8"
import script from "./ImgBlock.vue?vue&type=script&lang=js"
export * from "./ImgBlock.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abdulmanan/Sites/weapsmithing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__